import React from 'react';
import { useTranslation } from 'react-i18next';
import LinkButton from './LinkButton';

function GetInTouch() {
  const { t } = useTranslation();

  return (
    <div className="get-in-touch py-4">
      <div className="container">
        <div className="text-center pb-3">
          <h1>{t('getInTouch.title')}</h1>
          <p className="mb-4">
            {t('getInTouch.p1')}
            <br />
            {t('getInTouch.p2')}
          </p>
          <LinkButton
            label={t('getInTouch.buttonLabel')}
            name="contact-link"
            href="https://www.medel.com/contact-med-el"
          />
        </div>
      </div>
    </div>
  );
}

export default GetInTouch;
